export const STORAGE_LANGUAGE_KEY = 'i18nextLng';
export const SUPPORTED_LANGUAGES = ['ar', 'en', 'de'];
export const PATH_LANGUAGES_REGEX = /^\/(ar|en|de)/;
